import { FeedDocumentLocation } from '../../types';
import capitalize from '../../utils/capitalize';

export default function getUIFriendlyNameFromFeedDocumentLocation(input: FeedDocumentLocation) {
  return capitalize(input);
}
